import { render, staticRenderFns } from "./CustomQuestions.vue?vue&type=template&id=590b9989&scoped=true"
import script from "./CustomQuestions.vue?vue&type=script&lang=ts"
export * from "./CustomQuestions.vue?vue&type=script&lang=ts"
import style0 from "./CustomQuestions.vue?vue&type=style&index=0&id=590b9989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b9989",
  null
  
)

export default component.exports